import { render, staticRenderFns } from "./BookingAddTalentModal.vue?vue&type=template&id=36e68029"
import script from "./BookingAddTalentModal.vue?vue&type=script&lang=js"
export * from "./BookingAddTalentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports